import { render, staticRenderFns } from "./timeBeijing.vue?vue&type=template&id=474c5da7&scoped=true&"
import script from "./timeBeijing.vue?vue&type=script&lang=js&"
export * from "./timeBeijing.vue?vue&type=script&lang=js&"
import style0 from "./timeBeijing.vue?vue&type=style&index=0&id=474c5da7&scoped=true&lang=css&"
import style1 from "./timeBeijing.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474c5da7",
  null
  
)

export default component.exports